export enum Country {
  UK = `UK`,
  US = `US`,
  AU = `AU`,
  CN = `CN`,
}

export enum CountryCode {
  UK = `GB`,
  US = `US`,
  AU = `AU`,
  CN = `CN`,
}
